<template>
  <header>
    <h2>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="37.143"
        viewBox="0 0 26 37.143"
      >
        <g transform="translate(-280 -214)">
          <rect
            width="10.506"
            height="10.506"
            transform="translate(287.428 214) rotate(45)"
            fill="#c4c06d"
          />
          <rect
            width="10.506"
            height="10.506"
            transform="translate(298.571 225.143) rotate(45)"
            fill="#c4c06d"
          />
          <rect
            width="10.506"
            height="10.506"
            transform="translate(287.428 236.286) rotate(45)"
            fill="#c4c06d"
          />
        </g>
      </svg>
      <span class="title">天聖閣 {{ $halllist[id].name }}</span>
      <span class="subtitle">{{ $halllist[id].nameen }}</span>
    </h2>
    <div class="header-image">
      <img
        :src="require('../assets/images/' + id + '/mainimg.jpg')"
        :alt="$halllist[id].name"
      />
    </div>
    <div class="inner">
      <div class="tx">
        <h3>
          葬祭に必要なことすべてを
          <br />
          真心込めてお手伝い致します
        </h3>
        <p>
          ご家族だけのご葬儀からご会葬の方々が多い社葬まで、ご葬家のご要望に合わせて安心してご利用いただける落ち着きのある会葬ホールです。
          <br />
          上質のサービスとおもてなしの心で、ご会葬の方々をお迎えいたします。
        </p>
      </div>
    </div>
  </header>
  <section id="contents">
    <div class="information-grid">
      <div class="article">
        <div class="container">
          <h3>施設のご案内</h3>
          <div class="pickup-grid">
            <div
              class="item"
              v-for="(item, a) in $halllist[id].pickup"
              :key="a"
            >
              <div class="imgwrap">
                <img
                  :src="require('../assets/images/' + id + '/' + item.img)"
                  alt=""
                />
              </div>
              <div class="tx">
                <h4>{{ item.name }}</h4>
                <p>{{ item.text }}</p>
              </div>
            </div>
          </div>
          <VrGallery :galid="id" />
          <h3>祭壇のご紹介</h3>
          <Gallery :galid="id" />
          <h3>施設へのアクセス</h3>
          <div class="map-wrapper" v-html="$halllist[id].map"></div>
        </div>
        <div class="container">
          <ul class="notice">
            <li>・会館のご使用料は頂きません</li>
            <li>・火葬場に行かれる際は、マイクロバスで無料送迎いたします</li>
            <li>
              ・ご近所の方もご会葬いただけるように、会館まで無料送迎いた します
            </li>
            <li>・御親族様のご宿泊もできます</li>
            <li>・会館への食事・飲み物等お持込みは無料です</li>
            <li>・全室冷暖房完備、浴室もご用意しております</li>
          </ul>
        </div>
      </div>
      <div class="card">
        <h3>天聖閣 {{ $halllist[id].name }}</h3>
        <ul class="points">
          <li v-for="(point, k) in $halllist[id].points" :key="k">
            {{ point }}
          </li>
        </ul>
        <ul class="capacity">
          <li>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="16"
              height="16"
              viewBox="0 0 16 16"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect width="16" height="16" fill="#1a1a1a" />
                </clipPath>
              </defs>
              <g clip-path="url(#clip-path)">
                <path
                  d="M224.7,150.146h-1.854v2.78H224.7a1.487,1.487,0,0,0,1.077-.378,1.331,1.331,0,0,0,.392-1.005,1.356,1.356,0,0,0-.392-1.012,1.471,1.471,0,0,0-1.077-.385"
                  transform="translate(-215.88 -145.454)"
                  fill="#1a1a1a"
                />
                <path
                  d="M13.7,0H2.3A2.3,2.3,0,0,0,0,2.3V13.7A2.3,2.3,0,0,0,2.3,16H13.7A2.3,2.3,0,0,0,16,13.7V2.3A2.3,2.3,0,0,0,13.7,0M12.04,7.309a2.952,2.952,0,0,1-1.711,1.7,3.793,3.793,0,0,1-1.412.25H6.964v3.821H4.982V2.924H8.917a3.8,3.8,0,0,1,1.412.25,2.951,2.951,0,0,1,1.711,1.7,3.371,3.371,0,0,1,0,2.438"
                  fill="#1a1a1a"
                />
              </g>
            </svg>
            駐車場 {{ $halllist[id].parking }}台
          </li>
          <li>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="16"
              height="16"
              viewBox="0 0 16 16"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect width="16" height="16" fill="#1a1a1a" />
                </clipPath>
              </defs>
              <g transform="translate(0.004)">
                <g transform="translate(-0.004 0)" clip-path="url(#clip-path)">
                  <path
                    d="M0,2.187A2.185,2.185,0,1,0,2.185,0,2.185,2.185,0,0,0,0,2.187"
                    transform="translate(0.003 -0.001)"
                    fill="#1a1a1a"
                  />
                  <path
                    d="M2.206,154.565A2.562,2.562,0,0,0,.022,156.98v8.754H4.391V156.98a2.562,2.562,0,0,0-2.185-2.415"
                    transform="translate(-0.018 -149.735)"
                    fill="#1a1a1a"
                  />
                  <path
                    d="M188.266,4.37a2.185,2.185,0,1,0-2.185-2.184,2.185,2.185,0,0,0,2.185,2.184"
                    transform="translate(-180.263 0)"
                    fill="#1a1a1a"
                  />
                  <path
                    d="M188.265,154.565a2.562,2.562,0,0,0-2.185,2.415v8.754h4.37V156.98a2.562,2.562,0,0,0-2.185-2.415"
                    transform="translate(-180.262 -149.735)"
                    fill="#1a1a1a"
                  />
                  <path
                    id="パス_746"
                    data-name="パス 746"
                    d="M374.348,4.37a2.185,2.185,0,1,0-2.185-2.184,2.185,2.185,0,0,0,2.185,2.184"
                    transform="translate(-360.529 0)"
                    fill="#1a1a1a"
                  />
                  <path
                    id="パス_747"
                    data-name="パス 747"
                    d="M374.369,154.565a2.562,2.562,0,0,0-2.184,2.415v8.754h4.37V156.98a2.563,2.563,0,0,0-2.185-2.415"
                    transform="translate(-360.551 -149.735)"
                    fill="#1a1a1a"
                  />
                </g>
              </g>
            </svg>
            収容人数 {{ $halllist[id].capacity }}人
          </li>
        </ul>
        <p class="address">
          <span>{{ $halllist[id].zip }}</span>
          &nbsp;
          <span>{{ $halllist[id].address }}</span>
        </p>
        <a class="tel" :href="'tel:' + $halllist[id].tel">
          <img
            :src="require('../assets/images/tel-' + id + '.svg')"
            :alt="$halllist[id].tel"
          />
        </a>
      </div>
    </div>
  </section>
  <div class="contact-grid">
    <div class="contact-grid-inner">
      <div class="item" v-if="id != 'hondo'">
        <div class="imgwrap">
          <img src="@/assets/images/thumb-hondo.jpg" alt="天聖閣本渡斎場" />
        </div>
        <div class="tx">
          <h3>
            <img src="@/assets/images/logo01.svg" alt="天聖閣" />
            本渡斎場
          </h3>
          <router-link class="detail" to="/information/hondo">
            詳細をみる
          </router-link>
        </div>
      </div>
      <div class="item" v-if="id != 'itsuwa'">
        <div class="imgwrap">
          <img src="@/assets/images/thumb-itsuwa.jpg" alt="天聖閣五和斎場" />
        </div>
        <div class="tx">
          <h3>
            <img src="@/assets/images/logo01.svg" alt="天聖閣" />
            五和斎場
          </h3>
          <router-link class="detail" to="/information/itsuwa">
            詳細をみる
          </router-link>
        </div>
      </div>
      <div class="item" v-if="id != 'reihoku'">
        <div class="imgwrap">
          <img src="@/assets/images/thumb-reihoku.jpg" alt="天聖閣苓北斎場" />
        </div>
        <div class="tx">
          <h3>
            <img src="@/assets/images/logo01.svg" alt="天聖閣" />
            苓北斎場
          </h3>
          <router-link class="detail" to="/information/reihoku">
            詳細をみる
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <Footer></Footer>
</template>
<script>
import Footer from "@/components/PartsFooter.vue";
import VrGallery from "@/components/VrGal.vue";
import Gallery from "@/components/ImageGal.vue";
export default {
  props: ["id"],
  components: {
    VrGallery,
    Gallery,
    Footer,
  },
  setup() {},
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
header {
  padding: 0;
  padding-top: 145px;
  width: 100%;
  @include tb {
    padding-top: 80px;
  }
  h2 {
    display: flex;
    margin: 2.5rem auto;
    padding: 0 1rem;
    box-sizing: content-box;
    font-size: 2.25rem;
    gap: 1rem;
    max-width: $maxwidth;
    flex-grow: 1;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-start;
    @include tb {
      font-size: 1.5rem;
    }
    svg {
      height: 2.5rem;
    }
    .title {
      flex-grow: 0;
      flex-shrink: 0;
    }
    .subtitle {
      flex-grow: 0;
      color: #666;
      font-size: 1rem;
      padding-top: 0.5em;
      @include tb {
        font-size: 0.875rem;
      }
      @include sp {
        font-size: 0.65rem;
      }
    }
  }
  .header-image {
    width: 100%;
    height: 50vmin;
    @include sp {
      height: 65vmin;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .inner {
    margin: 2.5rem auto;
    margin-top: 0;
    padding: 0 1rem;

    .tx {
      border-bottom: 1px solid $color-lgray;
      padding: 2.5rem 0;
      max-width: $maxwidth;
      margin: 0 auto;
      h3 {
        text-align: center;
        font-size: 2rem;
        margin: 0 auto;
        line-height: 1.5;
        max-width: 640px;
        position: relative;
        padding-bottom: 2rem;
        margin-bottom: 2rem;
        &::after {
          @include pseudo;
          width: 6rem;
          height: 1px;
          left: calc(50% - 3rem);
          bottom: 0;
        }
        @include tb {
          font-size: 1.5rem;
        }
      }
      p {
        margin: 0 auto;
        max-width: 720px;
        line-height: 2;
      }
    }
  }
}
#contents {
  width: 100%;
  padding: 0 1rem;
  margin: 0 auto;

  .information-grid {
    margin: 0 auto;
    max-width: $maxwidth;
    display: flex;
    gap: calc($h-gap / 2);
    @include tb {
      flex-direction: column-reverse;
    }

    margin-bottom: 80px;
    .article {
      width: 100%;
      overflow: hidden;
      .container {
        width: 100%;
        background-color: white;
        padding: 1.5rem;
        margin-bottom: 2rem;
        &:last-child {
          margin-bottom: 0;
        }
        @include tb {
          padding: 1rem;
        }

        h3 {
          font-size: 1.5rem;
          padding-bottom: 1rem;
          padding-top: 0.5rem;
          margin-bottom: 2rem;
          border-bottom: 1px solid #ccc;
          margin-top: 2rem;
          &:first-child {
            margin-top: 0;
          }
          @include tb {
            font-size: 1.5rem;
          }
        }
        .pickup-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 2.5rem;
          margin-bottom: 2.5rem;
          @include tb {
            grid-gap: 2rem;
            grid-template-columns: 1fr;
          }
          .item {
            .imgwrap {
              width: 100%;
              height: auto;
              margin-bottom: 1.5rem;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .tx {
              h4 {
                font-size: 1.5rem;
                margin-bottom: 1rem;
                @include tb {
                  font-size: 1.25rem;
                }
              }
              p {
                line-height: 2;
                font-size: 0.875rem;
              }
            }
          }
        }
        .notice {
          font-size: 1rem;
          line-height: 1.5;
          @include tb {
            font-size: 0.875rem;
          }
          li {
            margin-bottom: 1rem;
          }
        }
      }
    }
    .card {
      max-width: 360px;
      padding: 1.5rem;
      padding-top: 0.5rem;
      top: calc(145px + 1rem);
      position: sticky;
      background-color: white;
      width: 100%;
      align-self: flex-start;
      @include tb {
        position: relative;
        top: 0;
        max-width: 100%;
        padding: 1rem;
      }
      h3 {
        font-size: 1.5rem;
        background-image: url(@/assets/images/dots.svg);
        background-position: 0 center;
        background-repeat: no-repeat;
        display: block;
        padding-left: 1.5rem;
        padding-bottom: 1rem;
        padding-top: 1rem;
        margin-bottom: 1rem;
        border-bottom: 1px solid #ccc;
        @include tb {
          font-size: 1.25rem;
        }
      }
      .points {
        padding-bottom: 1rem;
        margin-bottom: 1rem;
        border-bottom: 1px solid #ccc;
        li {
          font-size: 1.25rem;
          line-height: 2;
          display: inline-block;
          margin-right: 0.5em;
          @include tb {
            font-size: 1rem;
          }
        }
      }
      .capacity {
        padding-bottom: 1rem;
        margin-bottom: 1rem;
        border-bottom: 1px solid #ccc;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 0.5rem;
        @include tb {
          display: flex;
          gap: 1rem;
          font-size: 0.875rem;
        }
        li {
          display: inline-flex;
          align-items: center;
          gap: 0.25rem;
          svg {
            height: 1rem;
            width: 1rem;
          }
        }
      }
      .address {
        padding-bottom: 1rem;
        margin-bottom: 1rem;
        border-bottom: 1px solid #ccc;
        span {
          display: inline-block;
        }
        @include tb {
          font-size: 0.875rem;
        }
      }
      .tel {
        display: inline-flex;
        gap: 0.5rem;
        align-items: center;
        img {
          height: 32px;
          width: auto;
          @include tb {
            height: 24px;
            width: auto;
          }
        }
        &::before {
          content: "お問い合わせ";
          font-size: 0.75rem;
          flex-shrink: 0;
          color: $color-nagai;
        }
      }
    }
  }
}
.contact-grid {
  background-color: #eee;
  padding: 80px 1rem;
}
.contact-grid-inner {
  max-width: $maxwidth;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: clamp(16px, 5vw, 80px);
  margin: 0 auto;
  @include tb {
    grid-template-columns: 1fr;
  }
  .item {
    background-color: white;
    display: grid;
    grid-template-columns: 0.75fr 1fr;
    grid-gap: 0;
    .imgwrap {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .tx {
      padding: 1.5rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      h3 {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: clamp(1rem, 2vw, 1.5rem);
        width: 100%;
        margin-bottom: 1rem;

        img {
          font-size: clamp(1rem, 2vw, 1.5rem);
          width: auto;
          height: 1.5em;
          flex-grow: 0;
          margin-right: 1rem;
        }
      }
      .detail {
        width: 100%;
        display: block;
        text-align: center;
        color: $blue;
        border: 1px solid $blue;
        font-size: 1.25rem;
        padding: 0.5em 1em;
        @include tb {
          font-size: 1rem;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.map-wrapper {
  width: 100%;
  iframe {
    width: 100% !important;
    aspect-ratio: 16/9 !important;
  }
}
</style>
